module.exports = __webpack_public_path__ + "661f5dae10faf9763c60570b5ef5c8e9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/im.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/im.svg
// module chunks = 0